import { FC } from 'react';

import * as S from './ViewTransitionBar.styles';

interface ViewTransitionBarProps {
  progress: number;
}

export const ViewTransitionBar: FC<ViewTransitionBarProps> = ({ progress }) => {
  return <S.Bar $progress={progress} />;
};
